import { Pipe, PipeTransform } from '@angular/core';
import { UnitType } from '../models/unit.model';
import { metersToFeets } from '../helpers/meters-to-feets.helpers';
import { metersToMiles } from '../helpers/meters-to-miles.helpers';

@Pipe({
  name: 'distance',
})
export class DistancePipe implements PipeTransform {
  transform(
    value: number,
    unit: UnitType,
    output: 'value' | 'unit' | 'both' = 'value',
    rounded: number = 1,
  ): string {
    const data: {
      value: string;
      unit: string;
    } = this.getData(value, unit, rounded);
    switch (output) {
      case 'unit':
        return data.unit;
      case 'both':
        return `${data.value} ${data.unit}`;
      default:
        return data.value;
    }
  }

  getData(meters: number, unit: string, rounded: number): { value: string; unit: string } {
    if (unit === 'imperial') {
      const miles: number = metersToMiles(meters);
      const feets: number = metersToFeets(meters);
      return miles > 1
        ? { value: miles.toFixed(rounded), unit: 'miles' }
        : { value: feets.toFixed(), unit: 'ft' };
    }
    const kilometers: number = meters === 0 ? 0 : +(meters / 1000).toFixed(2);
    return meters > 1000
      ? { value: kilometers.toFixed(rounded), unit: 'km' }
      : { value: meters.toFixed(), unit: 'm' };
  }
}
